import React, { useContext } from "react";
import { AppBar, Toolbar, Typography, IconButton, Box, Select, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ThemeToggler from "./ThemeToggler";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";
import PropertyContext from "../contexts/PropertyContext";

const Navbar = ({ handleDrawerToggle, themeMode, toggleTheme, isLoggedIn, userProperties }) => {
  const propertyCtx = useContext(PropertyContext);
  const selectedProperty = propertyCtx?.selectedProperty;
  const setSelectedProperty = propertyCtx?.setSelectedProperty;

  return (
    <AppBar position="fixed">
      {isLoggedIn ? (
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ paddingLeft: 15 }}>
            RoomRoster
          </Typography>
          {userProperties?.length > 1 && (
            <Select
              value={selectedProperty || ""}
              onChange={(e) => {
                const picked = userProperties.find((p) => p.id === e.target.value);
                setSelectedProperty(e.target.value, picked?.clientId);
              }}
              size="small"
              variant="outlined"
              sx={{
                ml: 2,
                color: "inherit",
                ".MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.4)" },
                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.8)" },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "white" },
                ".MuiSvgIcon-root": { color: "inherit" },
              }}
            >
              {userProperties.map((prop) => (
                <MenuItem key={prop.id} value={prop.id}>
                  {prop.displayName}
                </MenuItem>
              ))}
            </Select>
          )}
          <Box sx={{ flexGrow: 1 }} />
          <ThemeToggler toggleTheme={toggleTheme} themeMode={themeMode} />
          <IconButton color="inherit" component={Link} to="/Profile">
            <AccountCircleIcon />
          </IconButton>
        </Toolbar>
      ) : (
        <Toolbar>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, paddingLeft: 15 }}>
            RoomRoster
          </Typography>
        </Toolbar>
      )}
    </AppBar>
  );
};

export default Navbar;
